// import jQuery from 'CommonScripts/jquery-1.10.2'; 

(function (window, document, $) {
     
    $(document).ready(function () {

        // Temporarily disabling highlight in search results
        // var searchResults = $('.search-result');
        
        // if (searchResults.length > 0) {
        //     var searchKeywords = $('section.search-result-box input').val().match(/\S+/g);
            
        //     $.each(searchKeywords, function (index, value) {
        //         if (value) {
        //             searchResults.highlight(value);
        //         }
        //     });
        // }

        /* Functionality for the Quick Search */
        function quickSearch($root) {
            $root = $($root);

            var quickSearch = {
                dom: {
                    input: $root.find('.search-box input'),
                    searchBtn: $root.find('.search-box .button a'),
                    clearBtn: $root.find('.search-box .icon-cross')
                },
                set: {
                    fullSearchUrl: $root.data('full-search-url'),
                    enterKey: 13
                },
                fn: {
                    fullSearch: function () {
                        var input = $dom.input.val();

                        // add filters
                        var filter = "";
                        jQuery(".search-box input:checkbox[id=chkSearchFilter]:checked").each(function () {
                            filter = filter + jQuery(this).attr('value') + ",";
                        });

                        if (filter !== "")
                            filter = "&filterSelected=" + filter.slice(0, -1);

                        if (input.length) {
                            location.href = $set.fullSearchUrl + input + filter;
                        }
                    },
                    clearQuickSearch: function () {
                        $dom.input.val('');
                    }
                }
            },
            /* Add quick access variables to be used in local function
                * Keep main variable name in case it needs to be shared with other JS files
                */
            $dom = quickSearch.dom,
            $set = quickSearch.set,
            $fn = quickSearch.fn;

            $dom.input.on({
                keydown: function (event) {
                    var code = event.keyCode || event.which;
                    if (code == $set.enterKey) {
                        event.preventDefault();
                        $fn.fullSearch();
                        return false;
                    }
                }
            });

            $dom.clearBtn.on({
                click: $fn.clearQuickSearch
            });

            $dom.searchBtn.on({
                click: function (event) {
                    event.preventDefault();
                    $fn.fullSearch();
                    return false;
                }
            });
        }


        /*  Clear the Search field at results page */
        //$.components.registerComponent('section.search-result-box', function ($root) {
        function clearSearchResults() {
            var $root2 = document.querySelectorAll('section.search-result-box');
            $root2 = $($root2);

            var resultSearch = {
                dom: {
                    input: $root2.find('.search-field input'),
                    clearBtn: $root2.find('.search-field .icon-cross')
                },
                fn: {
                    clearResultSearch: function () {
                        $dom.input.val('');
                    }
                }
            },
            /* Add quick access variables to be used in local function
                * Keep main variable name in case it needs to be shared with other JS files
                */
            $dom = resultSearch.dom,
            $fn = resultSearch.fn;

            $dom.clearBtn.on({
                click: $fn.clearResultSearch
            });
        }


        function init() {
            var search = document.querySelectorAll('aside.search');
            for (var i = 0; i < search.length; i++) {
                quickSearch(search[i]);
            }
            clearSearchResults();
        }

        init();

    });

})(window, document, jQuery);